/* eslint-disable max-len */
import React from 'react'
import { createIcon } from '@chakra-ui/icon'

const Home = createIcon({
    viewBox: '0 0 20 21',
    displayName: 'Home',
    path: (
        <path d="M20 19.879C20 20.1763 19.8829 20.4614 19.6746 20.6717C19.4662 20.8819 19.1836 21 18.8889 21H1.11111C0.816426 21 0.533811 20.8819 0.325437 20.6717C0.117063 20.4614 2.67456e-07 20.1763 2.67456e-07 19.879V8.09689C-0.000117204 7.92606 0.0384635 7.75746 0.112796 7.60397C0.187128 7.45048 0.295245 7.31616 0.428889 7.21127L9.31778 0.236195C9.51283 0.0831126 9.75289 0 10 0C10.2471 0 10.4872 0.0831126 10.6822 0.236195L19.5711 7.21127C19.7048 7.31616 19.8129 7.45048 19.8872 7.60397C19.9615 7.75746 20.0001 7.92606 20 8.09689V19.879ZM8.88889 12.0317V18.7579H11.1111V12.0317H8.88889Z" fill="#E0E4EC"/>
    ),
})

export default Home